import { Paragraph as ThemeUIParagraph } from 'theme-ui';

const Paragraph = (props) => <ThemeUIParagraph {...props}>{props.children}</ThemeUIParagraph>;

export default Paragraph;
